import { render, staticRenderFns } from "./PointsOfferSale.vue?vue&type=template&id=171d4b99"
import script from "./PointsOfferSale.vue?vue&type=script&lang=js"
export * from "./PointsOfferSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports